import { api } from "@/shared/api/api";
import type {
  TApiAccountNamesPayload,
  TApiAppAccountPayload,
  TApiPositionPayload,
} from "@/shared/api/types/clientPortal";

const accountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAccountInfo: builder.query<TApiAppAccountPayload, string>({
      query: (eid) => `/account/${eid}`,
      providesTags: (_result, _e, eid) => [{ type: "AccountInfo", id: eid }],
    }),
    getAccountNames: builder.query<TApiAccountNamesPayload, string[]>({
      query: (accountIds) => ({
        url: "/accounts/names",
        method: "POST",
        body: { accountIds },
      }),
    }),
    getAccountPosition: builder.query<TApiPositionPayload, string>({
      query: (eid) => `/position/${eid}`,
    }),
  }),
  overrideExisting: false,
});

export const { useGetAccountInfoQuery, useGetAccountNamesQuery, useGetAccountPositionQuery, endpoints } = accountApi;
